import { formatMoney } from '@fv/models/core'

import { UsageStat } from '../usage/UsageStat'

export const SystemStats = () => {
  return (
    <div className="grid grid-cols-5 gap-4">
      <UsageStat stat="active-users" label="Users with activity" />
      <UsageStat stat="loads-booked" label="Loads booked" />
      <UsageStat stat="loads-quoted" label="Loads quoted" />
      <UsageStat stat="olark-chats" label="Olark chats" />
      <UsageStat stat="ai-spend" label="AI spend" formatValue={formatMoney} />
    </div>
  )
}
